import { useImperativeHandle, useRef } from 'react';

import type { Ref, RefObject } from 'react';

export function useCascadeRef<T>(initialValue: T, forkRef?: Ref<T>): RefObject<T> {
  const ref = useRef<T>(initialValue);
  useImperativeHandle(forkRef, () => ref.current, [ref]);
  return ref;
}
